import React, { Component } from "react";
import { Link } from "react-router-dom";
import mediaImage from "./../../../assets/images/user.jpg";
import TwitterIcon from "../../../icons/twittericon";
import InstaIcon from "../../../icons/instaicon";
import FpgeeditIcon from "../../../icons/fpgediticon";
import FpgDisableIcon from "../../../icons/fpgdisableicon";
import FpgpublishIcon from "../../../icons/fpgpublishicon";
import FpgDeleteIcon from "../../../icons/fpgdeleteicon";
import Slider from "react-slick";
//moment import
import moment from "moment";
//Service import
import service from "../../../services";
import ErrorPopUp from '../../errorPopUp';
import RecordPresenceBanner from "../../RecordPresenceBanner";

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../../redux/bindActionCretor'
import PopUpCustomAll from "../create/popUpCustomAll";
import Loader from "../../loader";

let sub;

const mapStateToProps = state => ({
    otherEventId: state.otherEventId,
    filmEditId: state.filmEditId,
    recordViewers: state.recordViewers,
    recordConflict: state.recordConflict,
    getLoginAdminByID: state.getLoginAdminByID
})

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActCreators, dispatch);
};


class OtherEventsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      getAlldataTalkEventFilm: [],
      errorPopup: false,
      loaderFlag: false,
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
    };
    this.apiserve = new service();
    this._hasLeftPresence = false;
  }

  componentDidMount() {
    this.props.ClearRecordPresence();
    {
      this.props.otherEventId &&
      this.getAllTalkEventdetails();
      this.getTalkEventdetails();
    }
    this.setState({
      loaderFlag: true,
    });

    // RecordPresence: Join if recordId exists
    if (this.props.otherEventId) {
      this.apiserve.sendevent("RecordPresence|join", {
        modelName: "otherEvent",
        recordId: this.props.otherEventId
      });
      // Add beforeunload handler
      this._handleBeforeUnload = () => {
        if (!this._hasLeftPresence) {
          this._hasLeftPresence = true;
          this.apiserve.sendevent("RecordPresence|leave", {
            modelName: "otherEvent",
            recordId: this.props.otherEventId
          });
        }
      };
      window.addEventListener('beforeunload', this._handleBeforeUnload);
      // Add pageshow handler to reset flag if user cancels beforeunload
      this._handlePageShow = () => { this._hasLeftPresence = false; };
      window.addEventListener('pageshow', this._handlePageShow);
    }
  }

  componentWillUnmount = () => {
    sub.unsubscribe();
    if (this.props.otherEventId && !this._hasLeftPresence) {
      this._hasLeftPresence = true;
      this.apiserve.sendevent("RecordPresence|leave", {
        modelName: "otherEvent",
        recordId: this.props.otherEventId
      });
    }
    if (this._handleBeforeUnload) {
      window.removeEventListener('beforeunload', this._handleBeforeUnload);
    }
    if (this._handlePageShow) {
      window.removeEventListener('pageshow', this._handlePageShow);
    }
    this.props.ClearRecordPresence();
  }

  closeAdminUser = () => {
    this.setState({
      deleteFilm: false,
      publishFilm: false,
      disableFilm: false,
    });
  };

  errorMsgPopup = () => {
    this.setState({
      errorPopup: false
    })
  }

  getTalkEventdetails = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "otherEvent|getAllDetail":
          this.setState(
            {
              mediaId: response.data.mediaId,
              fileMakerId: response.data.fileMakerId,
              ytLink:response.data.ytLink,
              sponsorName:response.data.sponsorName,
              getTalkEventdetails: response.data,
              accessibility: response.data.accessibility,
              category: response.data.category.name,
              language:response.data.language,
              dateTime: response.data.dateTime,
              title: response.data.title,
              description: response.data.description,
              shortDescription:response.data.shortDescription,
              panelists: response.data.panelists,
              images: response.data.images,
              categoryname: response.data.category.name,
              status: response.data.status,
            },
            () => {
              this.setState({
                loaderFlag: false,
              });
              this.props.setLastUpdated({
                updatedAt: response?.data?.updatedAt,
                updatedBy: {
                  fname: response?.data?.updatedBy?.fname,
                  lname: response?.data?.updatedBy?.lname
                }
              });
            }
          );

          break;
        case "otherEvent|remove":
          if (!response.error) {
            this.props.history.push("/filmlist");
          }
          else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "otherEvent|updateStatus":
          if (!response.error) {
            this.setState({
              hideFromLiveFilm: false,
              disableFilm: false,
              publishFilm: false,
              showFromLiveFilm: false,
            })
            this.apiserve.success('Updated successfully')
            this.apiserve.sendevent("otherEvent|getAllDetail", { otherEventId: this.props.otherEventId });
          } else {
            this.setState({
              errorPopup: true,
              errorMsg: response.data.error ? response.data.error : response.data
            })
          }
          break;
        case "RecordPresence|viewersUpdate": {
          if (!response.error && response?.data?.recordId === this.props.otherEventId) {
            const currentUserId = this.props.getLoginAdminByID;
            const viewers = response?.data?.viewers || [];
            const currentUserSessionCount = viewers.filter(v => v?.userId === currentUserId).length;
            const currentUserHasMultipleSessions = currentUserSessionCount > 1;
            const seenIds = new Set();
            const filteredViewers = viewers
              .filter(v => {
                if (v?.userId === currentUserId) {
                  return currentUserHasMultipleSessions;
                }
                return true;
              })
              .filter(v => {
                if (seenIds.has(v?.userId)) return false;
                seenIds.add(v?.userId);
                return true;
              })
              .map(v => ({
                userId: v?.userId,
                userName: `${v?.fname || ''} ${v?.lname || ''}`.trim() || 'Unknown User'
              }));
            this.props.SetRecordViewers(filteredViewers);
          }
          break;
        }
      }
    });
  };

  getAllTalkEventdetails = () => {
    var data = { otherEventId: this.props.otherEventId };
    this.apiserve.sendevent("otherEvent|getAllDetail", data);
  };

  handelTwitter = (list) => {
    window.open(list.twitter, "_blank");
  };

  handelInstagram = (list) => {
    window.open(list.instagram, "_blank");
  };

  deleteFilm = () => {
    this.setState({
      deleteFilm: true,
    });
  };

  deleteFilmPopupYes = () => {
    this.apiserve.sendevent("otherEvent|remove", {
        otherEventId: this.props.otherEventId,
    });
  };

  publishFilm = () => {
    this.setState({
      publishFilm: true,
    });
  };

  publishFilmPopupYes = () => {
    this.apiserve.sendevent("otherEvent|updateStatus", {
        otherEventId: this.props.otherEventId,
      status: 1,
    });
  };

  disableFilm = () => {
    this.setState({
      disableFilm: true,
    });
  };

  disableFilmPopupYes = () => {
    this.apiserve.sendevent("otherEvent|updateStatus", {
        otherEventId: this.props.otherEventId,
      status: 2,
    });
  };

  editTalkAndEvent = () => {
    this.props.CurrentTab(4)
    this.props.history.push({
      pathname: `/create-film/${this.props.otherEventId}/edit`,
      callFrom: 4
    });
  };

  isShowLink = () => {
    const { dateTime } = this.state;
    var STATE = false;
    dateTime && dateTime.length > 0 && dateTime.forEach(date => {
        if(date.locationType === "2" || date.locationType === "3")
            STATE = true;
    });
    return STATE;
  }


  render() {
    var settings = {
      customPaging: function (i) {
        return <a>{i + 1}</a>;
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };
    const activeViewers = this.props.recordViewers || [];
    return (
      <>
        <RecordPresenceBanner activeViewers={activeViewers} conflict={null} />
        <div className="fpg_tabcontent d_flex">
          <div className="tab_col left_col">
            <div className="id_media">
              <span className="id_text d_block">
                <label>Media ID:</label> {this.state.mediaId}
              </span>
              <span className="id_text d_block">
                <label>Filemaker ID:</label> {this.state.fileMakerId}
              </span>
            </div>
            <Slider {...settings}>
              {this.state.images &&
                this.state.images.map((item) => (
                  <div>
                    <div className="media_image">
                      <img
                        src={
                          item.inSite ? this.apiserve.imageUrl + item.inSite :
                            item.link ? item.link :
                              '/images/image-placeholder.png'
                        }
                        alt="image"
                      />
                    </div>
                  </div>
                ))}
            </Slider>
            <div className="credit_section artist_section mt_15">
              <div className="credit_header">
                <h5>Panelists</h5>
              </div>
              {this.state.panelists &&
                this.state.panelists.map((list) => (
                  <div className="artist_content">
                    <div className="d_flex inner_artist">
                      <div className="artist_user">
                        <img
                          src={
                            list.image
                              ? this.apiserve.imageUrl + list.image
                              : '/images/user.png'
                          }
                          alt="user"
                        />
                      </div>
                      <div className="artist_data">
                        <div className="d_flex user_name">
                          <h4>{list.name}</h4>
                          <div className="d_flex d_flex_align_center">
                            {list.twitter &&
                              <Link className="d_flex d_flex_align_center"
                                onClick={() => this.handelTwitter(list)}
                              >
                                <TwitterIcon />
                              </Link>
                            }
                            {list.instagram &&
                              <Link
                                className="d_flex d_flex_align_center"
                                onClick={() => this.handelInstagram(list)}
                              >
                                <InstaIcon />
                              </Link>
                            }
                          </div>
                        </div>
                        <div className="user_desc">
                          <div className="editor_view p_0" dangerouslySetInnerHTML={{__html: list.description}} ></div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="tab_col feature_col">
            <div className="fpg_edits_links d_flex d_flex_align_center">
              <Link
                className="d_flex d_flex_align_center d_flex_justify_center"
                onClick={this.editTalkAndEvent}
              >
                <FpgeeditIcon />
                EDIT
              </Link>
              {this.state.status === 1 ? (
                <Link
                  className="d_flex d_flex_align_center d_flex_justify_center"
                  onClick={() => this.disableFilm()}
                >
                  <FpgDisableIcon /> DISABLE
                </Link>
              ) : (
                  <Link
                    className="d_flex d_flex_align_center d_flex_justify_center"
                    onClick={() => this.publishFilm()}
                  >
                    <FpgpublishIcon /> PUBLISH
                  </Link>
                )}
              <Link
                className="d_flex d_flex_align_center d_flex_justify_center"
                onClick={() => this.deleteFilm()}
              >
                <FpgDeleteIcon />
                DELETE
              </Link>
            </div>
            <p className="feature_text mt_10">{this.state.categoryname}</p>
            <div className="feature_title">
              <h3>{this.state.title}</h3>
              {/* <p>{this.state.description}</p> */}
              <div className="field_row mb_25">
                <label className="font_600"> Long Description</label>
                <div className="editor_view" dangerouslySetInnerHTML={{ __html: this.state.description }} />
              </div>  
              <div className="field_row mb_25">
                <label className="font_600"> Short Description</label>
                <div className="editor_view" dangerouslySetInnerHTML={{__html: this.state.shortDescription}} />
              </div>  
                
            </div>
            <div className="data_list">
            <ul>
            <li className="d_flex">
                  <label>Language</label>
                  <span>{this.state.language}</span>
                </li>
                <li className="d_flex">
                  <label>Category</label>
                  <span>{this.state.category}</span>
                </li>
                <li className="d_flex">
                  <label>Accessibility</label>
                  <span>
                    {this.state.accessibility &&
                      this.state.accessibility.map((item) => (
                        <p>{item.name}</p>
                      ))}
                  </span>
                </li>
                <li className="d_flex">
                  <label>Sponsor Name</label>
                  <span>{this.state.sponsorName}</span>
                </li>
              </ul>
            </div>
            <div className="screen_dates" style={{maxWidth:"610px"}}>
              <div className="header_title">
              <h3><label>Event Start Date & Time (MT)</label> - <label>Event End Date & Time (MT)</label> <label>Location</label><label>Waitlist Slots</label> <label>Open Caption</label></h3>
              </div>
              <div className="screen_list">
                <ul>
                  {this.state.dateTime &&
                    this.state.dateTime.map((date) => {
                      var talkAndEventStartDate = new Date(date.date);
                      var talksAndEventEndDate = new Date(date.endDate)
                      return (
                        <>
                          {" "}
                          <li className="mb_5 d_flex">
                            <span className="time_text time_text_nf">
                              {moment(talkAndEventStartDate).tz("US/Mountain").format('MMM DD')} {moment(talkAndEventStartDate).tz("US/Mountain").format('h:mm A')}  -  {moment(talksAndEventEndDate).tz("US/Mountain").format('MMM DD')} {moment(talksAndEventEndDate).tz("US/Mountain").format('h:mm A')}
                            </span>
                            <p className="d_flex">
                                { 
                                  date?.locationType === undefined || date.locationType === "2" ? <span className="d_block"> Online </span> :
                                  date?.locations.length > 0 ?  date?.locations.map((loc) => {
                                        return <span className="d_block"> {loc?.name} &nbsp;</span>
                                    }) : ''
                                }  
                            </p>
                            <p className="d_flex"><span className="d_block pl_25">{date.hasOwnProperty('maxWaitListSlots') && date?.maxWaitListSlots === 0 && date?.locationType === "1" ? <span className="sd_zero_waitlist_slots">0 Waitlist Slots</span> : date.hasOwnProperty('maxWaitListSlots') ? date?.maxWaitListSlots : 0}</span></p>
                            <p className="d_flex"><span className="d_block pl_25">{date.hasOwnProperty('accessibility') && date?.accessibility.length > 0 ? 'Y' : 'N'}
                              </span></p>
                          </li>
                        </>
                      )
                    })}
                </ul>
              </div>
            </div>

            {
              this.isShowLink() ?

              <div className="data_list">
                <ul>
                  <li className="d_flex">
                      <label>YT Event Link</label>
                      <span>{this.state.ytLink}</span>
                    </li>
                </ul>
              </div> : ''
            }
            
          </div>

          {this.state.errorPopup ?
            <ErrorPopUp
              errorMsg={this.state.errorMsg}
              errorMsgPopup={this.errorMsgPopup}
            />
            : ''
          }

          {this.state.deleteFilm ? (
            <PopUpCustomAll
              HeaderName="Delete?"
              insideDetails="You are about to delete an item and this action is permanent"
              insideData="Do you want to proceed?"
              popupState={this.closeAdminUser}
              yesPopUp={this.deleteFilmPopupYes}
            />
          ) : (
              ""
            )}

          {this.state.publishFilm ? (
            <PopUpCustomAll
              HeaderName="Publish Changes"
              insideDetails="Saving the current changes will publish it to the production site"
              insideData="Do you want to proceed?"
              popupState={this.closeAdminUser}
              yesPopUp={this.publishFilmPopupYes}
            />
          ) : (
              ""
            )}

          {this.state.disableFilm ? (
            <PopUpCustomAll
              HeaderName="Disable?"
              insideDetails="You are about to disable an item, which will temporarily make it unavailable on the production site"
              insideData="Do you want to proceed?"
              popupState={this.closeAdminUser}
              yesPopUp={this.disableFilmPopupYes}
            />
          ) : (
              ""
            )}
          {/* Loader */}
          {this.state.loaderFlag ? (
          <Loader />
            ) : (
                    ""
          )}
        </div>
      </>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OtherEventsView);
